/**
 * User service for managing user data, backed by Firestore (users/{uid}).
 */

import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

let currentUser = null;

/**
 * Get current user
 */
export const getCurrentUser = () => {
  return currentUser;
};

/**
 * Get user ID from user object (handles both 'id' and 'userId' fields)
 * @param {Object} user - User object
 * @returns {string|null} User ID or null if not found
 */
export const getUserId = (user) => {
  if (!user) return null;
  return user.id || user.userId || null;
};

/**
 * Set current user
 */
export const setCurrentUser = (user) => {
  currentUser = user;
};

const mapUser = (userId, data) => ({
  id: userId,
  name: data.name || '',
  email: data.email || '',
  organizationId: data.orgId || null,
  createdAt: data.createdAt || null,
  hasWeeklyPopup: data.hasWeeklyPopup === true,
});

/**
 * Get user by ID
 */
export const getUserById = async (userId) => {
  try {
    const snap = await getDoc(doc(db, 'users', userId));
    if (!snap.exists()) {
      throw new Error('Failed to fetch user');
    }
    return mapUser(userId, snap.data());
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};

/**
 * Update user
 */
export const updateUser = async (userId, updates) => {
  try {
    const ref = doc(db, 'users', userId);
    await updateDoc(ref, updates);
    const snap = await getDoc(ref);
    const mappedUser = mapUser(userId, snap.data());

    if (currentUser && currentUser.id === userId) {
      currentUser = mappedUser;
    }
    return mappedUser;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};
